import { ISelection } from '@codex/shared';

import {ITemporarySelection} from "features/codeEdit/codeEditSlice";

export const processBookmarks = (selections: (ISelection | ITemporarySelection)[]) =>
  selections.filter((selection) => selection.isBookmark);
